import { component, prop } from '../../../decorators';

import groupBy from 'lodash/groupBy';

import Tag from '../../../components/common/tag/tag.vue';

import TimedataSwitcher from '../../../components/common/timedata-switcher/timedata-switcher.vue';

@component({
   components: { Tag, TimedataSwitcher }
})
export default class MetadataTabs {
   @prop({ type: Array, default: () => [] }) metadata
   @prop({ type: Array, default: () => [] }) timedata
   @prop({ type: Array, default: () => [] }) selected
   @prop({ type: Number }) currentTime

   get timedataAsMap() {
      return groupBy(this.timedata, 'metadataId');
   }

   get list() {
      return this.metadata.map(data => {
         const selected = this.selected.some(i => i === data.id);
         const timedata = this.timedataAsMap[data.id] || [];
         return { ...data, selected, timedata };
      });
   }

   toggle(id) {
      const isSelected = this.selected.some(i => i === id);
      const selected = isSelected ? this.selected.filter(i => i !== id) : [ ...this.selected, id ];
      this.$emit('select', selected);
   }

   changeCurrentTime(time) {
      this.$emit('timeupdate', time);
   }
}
